<template>
  <div class="conntent">
    <div class="privacy_tit">
      《房品优选隐私政策》
    </div>

    <div class="privacy_text">
      生效日期：2022年07月11日
    </div>
    <div class="privacy_text">
      更新日期：2024年01月07日
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      【特别提示】请您仔细阅读我们的《房品优选隐私政策》（尤其是加粗字体的内容）并确定了解我们对您
      个人信息的处理规则。阅读过程中，如您有任何疑问，可及时与我们联系（联系方式以隐私政策里约定的为
      准）。如您不同意协议中的任何条款，您应立即停止访问房品优选。
      <!--			本隐私政策适用于房品优选杭州电猪科技有限公司（以下简称“房品优选”或“我们”）提供的房品优选产品和服务。房品优选通过app，小程序或其他方式提供房品优选营销系统平台，依据业务需求并结合用户角色(游客、普通用户、会员用户等）的不同为用户配置相应的服务内容及相关功能，包括访寻并沟通房源信息、在线选房，约看、邀请新的用户、平台奖励、在线商城等服务（以下简称“本服务”）。-->
      <!--			如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：-->
      <!--			电子邮件：fangpinyouxuan@foxmail.com 。-->
    </div>
    <div class="privacy_rule" style="font-weight: bold;">
      本政策将帮助您了解以下内容：
    </div>
    <div class="privacy_rules">
      1、我们如何收集和使用您的个人信息
    </div>
    <div class="privacy_rules">
      2、我们如何使用 Cookie 和同类技术
    </div>
    <div class="privacy_rules">
      3、我们如何共享、转让、公开披露您的个人信息
    </div>
    <div class="privacy_rules">
      4、我们如何保护您的个人信息
    </div>
    <div class="privacy_rules">
      5、您的权利
    </div>
    <div class="privacy_rules">
      6、我们如何处理未成年的个人信息
    </div>
    <div class="privacy_rules">
      7、本隐私政策如何更新
    </div>
    <div class="privacy_rules">
      8、本政策如何更新。
    </div>
    <div class="privacy_rules">
      9、如何联系我们。
    </div>
    <div class="privacy_text">
      房品优选（以下亦称“我们”）深知个人信息对您的重要性，我们尊重并保护所有使用房品优选平台服务的用户
      的个人隐私权，并会尽全力保护您的个人信息安全可靠。同时，我们承诺，我们将按业界成熟的安全标准，采
      取相应的安全保护措施来保护您的个人信息。 请在使用我们的产品（或服务）前，仔细阅读并了解本《房品优选隐私政策》（下称“本隐私政策”）。
      如您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以通过发送邮件至
      fangpinyouxuan@foxmail.com 。
    </div>
    <div class="privacy_second" style="font-weight: bold;">
      一、我们处理个人信息的总原则
    </div>
    <div class="privacy_text">
      房品优选仅会出于本政策所述的以下目的，遵循合法、正当、必要的原则，收集和使用实现产品功能所必要的您的个人信息：
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      1.1 登录注册信息
    </div>
    <div class="privacy_text">
      您需要通过微信、手机号或者苹果账号授权登录本平台，您将向我们授权使用您的微信账号公开信息，包括
      <strong class="privacy_mark">微信昵称、头像、性别、地区以及微信绑定的手机号</strong>。微信登录后您可以仅浏览信息，如您需要在线选房、在线商城、房源分享或在线咨询服务功能。
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      1.2 为实现产品的具体功能所需信息
    </div>
    <div class="privacy_text">
      1.2.1 在线商城功能
    </div>
    <div class="privacy_text">
      您可以按照在线商城规则采购相应商品/服务。您同意向我们提供用户注册信息，指定购买人（如有）的<strong>姓名、手机号码、证件号码</strong>以完成交易，我们及支付机构将收集和使用这些信息和订单记录，以实现交易目的。若您不提供前述信息，我们及支付机构将无法为您提供相应服务。
    </div>
    <div class="privacy_text">
      1.2.2 信息发布
    </div>
    <div class="privacy_text">
      房品优选向用户提供即时通讯功能，使用这些服务时，您需要授权我们使用<strong>您的相机、麦克风权限</strong>等设备权限才能发布图片和语音；您的昵称、头像将会被查询或公开；平台工作人员可以查看您上传发布的其他文字、视频、照片等。请您注意在信息发布时谨慎披露涉及个人的隐私性或敏感性信息。
    </div>
    <div class="privacy_text">
      1.2.3 位置服务
    </div>
    <div class="privacy_text">
      某些位置服务，例如登陆时为您自动切换所在城市、地图选房、地图导航，需要您的<strong>GPS位置信息</strong>。我们会向您做出告知并获得您的授权。您可以拒绝授权或关闭设备功能设置停止我们对地理位置信息的收集，但这将导致我们无法向您提供相应的服务或无法达到服务效果。
    </div>
    <div class="privacy_text">
      1.2.4 围观楼盘
    </div>
    <div class="privacy_text">
      我们会根据您所选择地区的全部房源信息，以便于您更便捷的访寻并了解相应地区的热门房源信息。为保障用户访问记录的真实性，我们会收集并披露您的访问记录信息，包括您的<strong>微信昵称、头像、访问时间</strong>。
    </div>
    <div class="privacy_text">
      1.2.5 设备权限信息
    </div>
    <div class="privacy_text">
      房品优选提供服务过程中可能需要您向我们开启设备访问权限，例如<strong>相机（摄像头）、网络、麦克风、位置</strong>的访问权限，以实现这些功能所涉及的信息的收集和使用。我们会在需要开启权限时向您说明用途并征得您的同意，您开启这些权限即代表您授权我们可以收集和使用这些信息来实现相应功能。您也可以通过设备设置取消授权，我们则无法为您提供上述与这些授权所对应的功能。
    </div>
    <!--    <div class="privacy_text" style="font-weight: bold;">-->
    <!--      1.3 我们间接获取的个人信息-->
    <!--    </div>-->
    <!--    <div class="privacy_text" style="font-weight: bold;">-->
    <!--      我们采取以下两种方式间接获取您的个人信息：-->
    <!--    </div>-->
    <!--    <div class="privacy_text">-->
    <!--      1.3.1 由房品优选运营的其他产品或服务中获取-->
    <!--      您同意我们将房品优选不同产品中收集的个人信息进行关联、汇集和融合。当您注册后，我们将关联同一注册账户在房品优选系统中的个人信息，包括您的购房信息、认筹信息、选房记录、购房优惠券等。我们可以这种数据处理方式为您提供注册便利、或免去您多次提交个人信息的重复性操作，或进行业主身份和权益确认，账户安全风险防范。我们将会依据现有法律法规、规范性文件及相关国家标准的要求实施相应的制度和措施，开展个人信息安全影响评估，采取适当的个人信息保护措施，以保护融合后的个人信息数据安全。-->
    <!--    </div>-->
    <!--    <div class="privacy_text">-->
    <!--      1.3.2 由房品优选之外的第三方获取-->
    <!--      当我们从房品优选之外的第三方获取您的个人信息的，包括房品优选的关联公司以及第三方合作机构，我们将依据现有法律法规、规范性文件及相关国家标准的要求，尽合理努力核实该等第三方合作机构已获得您向我们提供个人信息的合法授权及具体授权范围和期限。若我们计划超出您的授权范围使用您的个人信息的，我们将获取您的事先同意，届时，房品优选将作为个人信息的被授权方，就您的个人信息使用授权达成新的授权许可。-->

    <!--    </div>-->
    <div class="privacy_text">
      1.3 基于其他目的使用您的个人信息
    </div>
    <div class="privacy_text">
      1.3.1 与您沟通。
    </div>
    <div class="privacy_text">
      为保障本服务（无论线上或线下）开展和质量，我们会使用您的手机号码或通过产品中的内置客服系统与您沟通。例如，我们可能与您联系，让您了解房品优选的业务最新资讯，对您使用的房品优选服务进行回访。
    </div>
    <div class="privacy_text">
      <!--      1.3.2 开展内部审计、数据分析和研究。-->
      1.3.2 我们将使用收集的信息在房品优选内部进行必要的内部审计。
    </div>
    <!--    <div class="privacy_text">-->
    <!--      a) 我们将使用收集的信息在房品优选内部进行必要的内部审计。-->
    <!--    </div>-->
    <!--    <div class="privacy_text">-->
    <!--      b)-->
    <!--      我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品，展示房品优选服务的整体全貌，分析不同群体的行为模式等。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。-->
    <!--    </div>-->
    <!--    <div class="privacy_text">-->
    <!--      c)-->
    <!--      我们会基于经授权合法收集的个人信息，通过信息系统、算法等非人工自动决策技术实现标签化或画像处理，从而做出的自动决策决定（如商业化信息推送），如果您不希望参与此类定向广告信息推送，请通过第九部分的联系方式要求我们作出解释，我们也将提供适当的救济方式。-->
    <!--    </div>-->
    <div class="privacy_text">
      1.3.3 改善房品优选的产品或服务。
    </div>
    <div class="privacy_text">
      我们可能收集您在使用本服务时的设备信息、网络信息或个人行为信息，改进房品优选的产品和服务，进行必要的业务运营与评估、客户支持，包括：
    </div>
    <div class="privacy_text">
      a) 设备的软硬件信息。例如在后台状态下获取了用户的<strong>MAC信息、设备型号、软件安装列表、操作系统版本、唯一设备标识符、ANDROID
      ID、信号强度</strong>等信息；<strong>软件的版本号</strong>。您通过开启的设备设置允许我们接收的信息，包括访问您的<strong>GPS
      位置、电话</strong>。
    </div>
    <div class="privacy_text">
      b) 设备连接和网络状态信息，如<strong>电信运营商、使用的语言，IP地址，设备传感器数据</strong>。
    </div>
    <div class="privacy_text">
      c) 服务使用信息。我们会通过服务日志或其他技术手段记录您使用我们产品的时间和上一次使用时间，以及您在我们的产品中查看和停留信息，以便我们优化产品和服务。
    </div>
    <div class="privacy_text">
      1.3.4 安全保障。
      我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。为了验证您提供信息的准确性和完整性，或保障您的账号安全，我们会与合法留存您的信息的国家机关、金融机构、企事业单位进行核对。
    </div>
    <div class="privacy_text">
      1.4 其他说明
    </div>
    <div class="privacy_text">
      1.4.1 当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
    </div>
    <div class="privacy_text">
      1.4.2 但是，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
    </div>
    <div class="privacy_text">
      a) 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；
    </div>
    <div class="privacy_text">
      b) 与犯罪侦查、起诉、审判和判决执行等直接相关的；
    </div>
    <div class="privacy_text">
      c) 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
    </div>
    <div class="privacy_text">
      d) 所收集的个人信息是您自行向社会公众公开的；
    </div>
    <div class="privacy_text">
      e) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    </div>
    <div class="privacy_text">
      f) 根据您要求签订和履行合同所必需的；
    </div>
    <div class="privacy_text">
      g) 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
    </div>
    <div class="privacy_text">
      h) 为开展合法的新闻报道所必需的；
    </div>
    <div class="privacy_text">
      i) 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </div>
    <div class="privacy_text">
      j) 法律法规规定的其他情形。
    </div>
    <div class="privacy_second" style="font-weight: bold;">
      二、我们如何共享、转让、公开披露您的个人信息
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      2.1 共享
    </div>
    <div class="privacy_text">
      2.1.1 统一账号
    </div>
    <div class="privacy_text">
      房品优选APP是杭州电猪科技有限公司所提供的产品之一。为确保服务的连续性和统一性，您了解并同意，使用统一账户，即您在房品优选注册的账号可以登录房品优选会员账号其他产品，且房品优选账号中的个人信息将关联其他产品的同一账号下，反之亦然。
    </div>
    <div class="privacy_text">
      2.1.2 我们不会与房品优选以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：
    </div>
    <div class="privacy_text">
      a)
      根据您使用本服务中的指示，在获取明确同意的情况下共享。例如：当您进行奖励结算或商品/服务结算时，与支付机构验证您的银行卡信息共享佣金发放记录/订单记录；当您使用积分商城兑换实物，与物流公司共享您的<strong>收件地址、收件人姓名、联系方式</strong>等个人信息。
    </div>
    <div class="privacy_text">
      b)
      与我们的关联公司共享：您的个人信息可能会与房品优选的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。例如：我们将为您的奖励结算服务目的，与您所推荐房源所属的关联公司共享您的<strong>注册信息、银行卡信息和奖励结算信息</strong>。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
    </div>
    <div class="privacy_text">
      c)
      与授权合作伙伴共享：仅为实现本服务具体功能的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，为我们提供短消息服务的供应商，我们会共享您的<strong>手机号码信息</strong>；为我们提供地图服务的地图服务商，我们会共享<strong>位置信息</strong>；为我们提供支付聚合服务的供应商，我们会共享您的<strong>注册信息</strong>；为我们提供统计分析服务的，我们会共享您的手机设备相关的信息，如<strong>IP地址、设备号</strong>等。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
    </div>
    <div class="privacy_text">
      d) 我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      3.1.3 对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
    </div>
    <div class="privacy_text">
      3.1.4 为避免歧义，您应知悉并了解，
      相关产品中可能含有其他独立第三方运营的网站、应用程序、产品和服务的链接，我们对此第三方网站、应用程序、产品和服务不作任何明示和默示的保证，该类链接仅为方便用户浏览相关页面而提供。当您访问该等第三方网站、应用程序、产品和服务链接时，应另行同意其为您提供的隐私政策或个人信息保护条款。我们与该等第三方网站、应用程序、产品和服务提供者在法律规定和双方约定的范围内各自向您承担独立的个人信息保护责任。
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      3.2 转让
    </div>
    <div class="privacy_text">
      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
    </div>
    <div class="privacy_text">
      3.2.1 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
    </div>
    <div class="privacy_text">
      3.2.2 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会告知您并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      3.3 公开披露
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      我们仅会在以下情况下，公开披露您的个人信息：
    </div>
    <div class="privacy_text">
      3.3.1 获得您明确同意后；
    </div>
    <div class="privacy_text">
      3.3.2 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
    </div>
    <div class="privacy_text" style="font-weight: bold;">
      4. 我们如何保护您的个人信息
    </div>
    <div class="privacy_text">
      4.1 我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的设备与
      “服务器”之间交换数据（如信用卡信息）时受 SSL
      加密保护；我们同时会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    </div>
    <div class="privacy_text">
      4.2
      我们的数据安全能力：房品优选有强大的信息安全部门为房品优选的产品构建完整先进的数据安全保护体系，包括对用户信息进行识别、加密保存、数据访问权限划分；制定了内部数据管理制度和操作规程，从数据的获取、使用、销毁都有严格的流程要求，避免用户隐私数据被非法使用；确定接触用户个人信息的各部门及其负责人安全管理责任；建立用户个人信息收集、使用及其相关活动的工作流程和安全管理制度；
      对工作人员及代理人实行权限管理，对批量导出、复制、销毁个人信息实行审查，并采取防泄密措施；
      妥善保管记录用户个人信息的纸介质、光介质、电磁介质等载体，并采取相应的安全储存措施；对储存用户个人信息的信息系统实行接入审查，并采取防入侵、防病毒等措施；记录对用户个人信息进行操作的人员、时间、地点、事项等信息；定期举办安全和隐私保护培训，提高员工的个人信息保护意识。
    </div>
    <div class="privacy_text">
      4.3 我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在本隐私政策所述目的所需的期限内保留您的个人信息，除非征得您的同意需要延长保留期或受到法律的允许。
    </div>
    <div class="privacy_text">
      4.4 互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
    </div>
    <div class="privacy_text">
      4.5
      在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
      同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      若您发现您的个人信息泄露时，请您立即通过本隐私政策约定的联系方式与我们联系，以便我们及时采取相应措施。

    </div>
    <div class="privacy_text">
      5. 您的权利
    </div>

    <div class="privacy_text">
      按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们将努力保障您对自己的个人信息行使以下权利：
    </div>
    <div class="privacy_text">
      5.1 访问您的个人信息
    </div>
    <div class="privacy_text">
      5.1.1 您有权访问您的个人信息。
    </div>
    <div class="privacy_text">
      您可以进入“房品优选-我的”， 点击页面上方用户名后，查看个人信息，包括头像、用户名；
    </div>
    <div class="privacy_text">
      5.1.2 如果您无法通过前述途径访问个人信息，您可以随时通过第九部分的联系方式联系我们，我们将在合理期限内回复您的访问请求。
    </div>
    <div class="privacy_text">
      5.2 更正您的个人信息
    </div>
    <div class="privacy_text">
      5.2.1 当您发现我们处理的关于您的个人信息有错误时：
      您可以进入“房品优选-我的”， 点击页面上方用户名后，修改个人信息，包括头像、用户名；

    </div>
    <div class="privacy_text">
      5.2.2 如果您无法通过前述途径更正这些个人信息，您可以随时通过第九部分的联系方式联系我们，我们将在合理期限内回复您的更正请求。
    </div>
    <div class="privacy_text">
      5.3 删除您的个人信息
    </div>
    <div class="privacy_text">
      5.3.1 在以下情形中，您可以随时通过第九部分的联系方式联系我们，向我们提出删除个人信息的请求：
    </div>
    <div class="privacy_text">
      a) 如果我们处理个人信息的行为违反法律法规；
    </div>
    <div class="privacy_text">
      b) 如果我们收集、使用您的个人信息，却未征得您的同意；
    </div>

    <div class="privacy_text">
      c) 如果我们处理个人信息的行为违反了与您的约定；
    </div>
    <div class="privacy_text">
      d) 如果您不再使用我们的产品或服务，或您注销了账号；
    </div>
    <div class="privacy_text">
      e) 如果我们不再为您提供产品或服务。
    </div>
    <div class="privacy_text">
      5.3.2 若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
    </div>
    <div class="privacy_text">
      5.3.3 当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    </div>
    <div class="privacy_text">
      5.4 改变您授权同意的范围
    </div>
    <div class="privacy_text">
      5.4.1 对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。
    </div>
    <div class="privacy_text">
      5.4.2 您可以通过更改手机设备中的相机等访问权限或更改浏览器功能设置、更改产品的设置选项，或者向我们第九部分的联系方式发送通知的方式改变授权同意的范围。
    </div>
    <div class="privacy_text">
      5.4.3 当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
    </div>
    <div class="privacy_text">
      5.4.4 特别地，如果您不想接受我们给您发送的商业性促销信息，您可通过短信息上明确告知的退订方式回复取消推送或联系我们。
    </div>
    <div class="privacy_text">
      5.5 个人信息主体注销账户
    </div>
    <div class="privacy_text">
      5.5.1 您随时通过第九部分的联系方式申请注销账户。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。
    </div>
    <div class="privacy_text">
      5.5.2
      请注意，若您在注销时存在需要您履行义务的事宜，且在法律法规允许的范围内，您的注销申请不会被立即支持。当您确认注销成功后，账户信息、个人身份证信息、交易记录、会员权益等将无法恢复或提供；但您仍应对您在注销账号前且使用平台服务期间的行为承担相应责任。
    </div>
    <div class="privacy_text">
      5.6 个人信息主体获取个人信息副本
    </div>
    <div class="privacy_text">
      5.6.1 您有权获取您的个人信息副本，若我们有获取您的个人基本资料、个人身份信息、个人健康生理信息和个人教育工作信息，您可以通过联系我们索要上述信息的副本。
    </div>
    <div class="privacy_text">
      5.6.2 在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
    </div>
    <div class="privacy_text">
      5.7 响应您的上述请求
    </div>
    <div class="privacy_text">
      5.7.1 为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    </div>
    <div class="privacy_text">
      5.7.2 一般情况下我们将在十五天内回复您的权利请求。如您不满意，还可以通过第九部分的联系方式进行投诉。
    </div>
    <div class="privacy_text">
      5.7.3
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    </div>
    <div class="privacy_text">
      5.7.4 在以下情形中，按照法律法规要求，我们将无法响应您的请求：
    </div>
    <div class="privacy_text">
      a) 与个人信息控制者履行法律法规规定的义务相关的；
    </div>
    <div class="privacy_text">
      b) 与公共安全、公共卫生、重大公共利益直接相关的；
    </div>
    <div class="privacy_text">
      c) 与犯罪侦查、起诉、审判和判决执行等直接相关的；
    </div>
    <div class="privacy_text">
      e) 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
    </div>

    <div class="privacy_text">
      f) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；与国家安全、国防安全直接相关的；
    </div>
    <div class="privacy_text">
      g) 涉及商业秘密的。
    </div>
    <div class="privacy_text">
      6. 我们如何处理儿童的个人信息
    </div>
    <div class="privacy_text">
      6.1我们的服务仅限16岁以上的用户使用，如果您未满16周岁，请您立即停止使用我们的服务。您应明确了解，若我们在服务过程中发现或怀疑您未满16周岁的，则我们可以随时中止或终止向您提供服务，直至您向我们提供您已满16周岁的证明，或协助我们获得您的监护人的明示同意。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
      在此情形下，如果我们发现自己在未事先获得父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
    </div>
    <div class="privacy_text">
      6.2
      我们的服务仅限18岁以上的用户使用，如果您未满18周岁，请您立刻停止使用我们的服务；您应明确了解，若我们在服务过程中发现或怀疑您未满18周岁的，则我们可以随时中止或终止向您提供服务，直至您向我们提供您已满18周岁的证明。在此情形下，如果我们发现自己在未事先获得父母同意的情况下收集了儿童的个人信息，则会尽快删除相关数据。
    </div>
    <div class="privacy_text">
      7. 您的个人信息如何在全球范围转移
      原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。

    </div>
    <div class="privacy_text">
      8. 本政策如何更新
    </div>
    <div class="privacy_text">
      8.1
      请您理解，由于房品优选向您提供的功能和服务是不断更新和发展的，我们将努力贯彻“隐私保护设计”的理念，完善我们的产品设计，通过页面提示、公告或交互流程等方式及时向您说明个人信息收集的内容、范围和目的，作为本隐私政策的必要补充。
    </div>
    <div class="privacy_text">
      8.2 未经您明确同意，我们不会削减您按照隐私政策所应享有的权利。我们会发布对隐私政策的更新版本。
      对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知、短信通知或站内通知等，说明隐私政策的具体变更内容）。
    </div>
    <div class="privacy_text">
      8.3 隐私政策的重大变更包括但不限于：
    </div>
    <div class="privacy_text">
      8.3.1 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </div>
    <div class="privacy_text">
      8.3.2 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
    </div>
    <div class="privacy_text">
      8.3.3 个人信息共享、转让或公开披露的主要对象发生变化；
    </div>

    <div class="privacy_text">
      8.3.4 您参与个人信息处理方面的权利及其行使方式发生重大变化；
    </div>
    <div class="privacy_text">
      8.3.5 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
    </div>
    <div class="privacy_text">
      8.3.6 个人信息安全影响评估报告表明存在高风险时。
    </div>
    <div class="privacy_text">
      9. 如何联系我们
    </div>
    <div class="privacy_text">
      9.1 如果您对隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：fangpinyouxuan@foxmail.com
    </div>
    <div class="privacy_text">
      9.2 我们设立了个人信息保护专员，您可以通过以下方式与其联系，一般情况下，我们将在十五天内回复。
    </div>
    <div class="privacy_text">
      杭州电猪科技有限公司
    </div>
    <div class="privacy_text">
      地址：浙江省杭州市江干区下沙街道 和达高科·生命科技中心13F
    </div>
    <div class="privacy_text">
      邮箱：fangpinyouxuan@foxmail.com
    </div>
    <div class="privacy_text">
      9.3
      如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，且协商无法达成一致的，任何一方均可将有关争议提交至房品优选所在城市的仲裁院（杭州仲裁委员会）并按照其届时有效的仲裁规则仲裁；仲裁裁决是终局的，对各方均有约束力。
    </div>
    <div class="privacy_second">
      附录:
    </div>
    <div class="privacy_text">
      1>个人信息
    </div>
    <div class="privacy_text">
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。
    </div>
    <div class="privacy_text">
      2>个人敏感信息
    </div>
    <div class="privacy_text">
      个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。例如，个人敏感信息包括个人电话号码、身份证件号码、网页浏览记录、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、住宿信息、精准定位信息、健康生理信息、交易信息、14岁以下（含）儿童的个人信息等。
    </div>
    <div class="privacy_text">
      3>房品优选集成的第三方SDK
    </div>
    <div class="privacy_text">
      由于业务的需求，在房品优选APP的第三方sdk如下列表，其中涉及的隐私，请参考相关链接。
    </div>
    <div class="privacy_serve">
      客户服务联系方式：
    </div>
    <div class="privacy_serve">
      电话：0571-87813887
    </div>
    <div class="privacy_serve">
      地址：浙江省杭州市江干区下沙街道 和达高科·生命科技中心13F
    </div>
    <div class="privacy_serve">
      邮箱：fangpinyouxuan@foxmail.com
    </div>
    <div class="privacy_table">
      <div class="table_head">房品优选SDK列表信息</div>
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column
            prop="date"
            label="使用SDK名称"
            width="120">
        </el-table-column>

        <el-table-column
            prop="address"
            width="220"
            label="使用目的">
        </el-table-column>

        <el-table-column
            prop="name"
            width="220"
            label="收集的个人信息类型">
        </el-table-column>

        <el-table-column
            prop="links"
            width="220"
            label="第三方隐私协议的链接">
        </el-table-column>

      </el-table>
    </div>
  </div>

</template>

<script>
export default {
  name: "privacy_policy",
  data() {
    return {
      tableData: [
        {
          date: '高德开放平台地图SDK',
          name: '经纬度、设备信息【如IP 地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）',
          address: '为了实现地图展示、定位、搜索等服务',
          links: 'https://lbs.amap.com/pages/privacy/'
        },
        {
          date: '支付宝',
          name: '设备标识信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息以及地理位置信息 ',
          address: '支付宝支付',
          links: 'https://opendocs.alipay.com/apis/01g6qm'
        },
        {
          date: '微信SDK',
          name: '设备标识信息',
          address: '接入微信开放平台SDK，支持微信授权登录、微信分享和微信支付',
          links: 'https://mp.weixin.qq.com/cgi-bin/announce?action=getannouncement&key=1503979103&version=1&lang=zh_CN&platform=2'
        },
        {
          date: '友盟统计',
          name: '设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息',
          address: '进行APP运营统计与分析',
          links: 'https://www.umeng.com/page/policy'
        },
        {
          date: '友盟分享',
          name: '设备信息（IMEI/MAC/Android ID/OAID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/IP/地理位置等）、应用列表',
          address: '用于唯一标识设备，以便向目标设备分享消息',
          links: 'https://www.umeng.com/page/policy'
        },
        {
          date: '闪验SDK',
          name: '为了实现网关取号技术，闪验 SDK 需要获取 IP 地址、网卡（MAC)地址、国际移动设备识别码（IMEI）、OAID（替代 IMEI）、sim 卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志等数据以提供统计分析服务能力，并可提供反欺诈等功能',
          address: '一键登录、本机号校验',
          // links:'http://api.253.com/api_doc/yin-si-zheng-ce/ge-ren-xin-xi-bao-hu-sheng-ming.html'
          // links: 'https://static.253.com/chuanglan/flash-policy.html'
          links: 'https://doc.chuanglan.com/document/T98GE1KYCZDMJDHN'
        },
        {
          date: '腾讯bugly',
          name: '设备型号、操作系统版本、 唯一设备标识符、信号强度、位置信息、IP地址、地理位置信息 ',
          address: '统计应用运行异常错误数据',
          links: 'https://privacy.qq.com/'
        },
        {
          date: '中国移动认证（闪验SDK集成）',
          name: '设备标识信息（如IMEI)、网络类型、网络地址、运营商类型、本机号码、手机设备类型、手机操作系统、硬件厂商',
          address: '识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制',
          links: 'http://wap.cmpassport.com/resources/html/contract.html'
        },
        {
          date: '中国电信认证（闪验SDK集成）',
          name: '网络 IP 地址、网络类型、注册手机号码、本机号码、国际移动用户标识码、应用进程信息、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本',
          address: '识别⽤户的⼿机号码快速登录/号码校验及业务风控',
          links: 'https://e.189.cn/sdk/agreement/detail.do?hidetop=true'
        },
        {
          date: '中国联通认证（闪验SDK集成）',
          name: '网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商',
          address: '识别⽤户的⼿机号码快速登录/号码校验 信息',
          links: 'https://ms.zzx9.cn/html/oauth/protocol2.html'
        },
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
.conntent {
  padding: 16px;

  .privacy_tit {
    font-size: 18px;
    color: #444;
    font-weight: 800;
    text-align: center;
    margin-bottom: 10px;
  }

  .privacy_second {
    font-size: 14px;
    color: #444;
    font-weight: 800;
  }

  .privacy_text {
    font-size: 14px;
    color: #444;
    line-height: 28px;
    text-indent: 36px;
  }

  .privacy_rule {
    font-size: 14px;
    color: #444;
    line-height: 40px;
  }

  .privacy_rules {
    font-size: 14px;
    color: #444;
    text-indent: 30px;
  }

  .privacy_serve {
    font-size: 14px;
    color: #999;
    font-weight: 600;
  }

  .privacy_mark {
    font-size: 14px;
    color: #444;
    line-height: 28px;
    text-indent: 36px;
  }

  .privacy_table {
    .table_head {
      width: 100%;
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      color: black
    }
  }
}
</style>
